// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IpRowComponent_ipItem__oN47v {
    background: rgba(32, 38, 50, 0.85); 
    backdrop-filter: blur(8px);
    border-radius: 8px;
    padding: 0.6rem 1.2rem; /* Etwas flacher für mehr Informationsdichte */
    margin-bottom: 0.6rem;
    display: flex;
    align-items: center; /* Vertikale Zentrierung aller Spalten */
    justify-content: space-between;
    gap: 1.5rem;
    border: 1px solid rgba(255, 255, 255, 0.05);
    list-style: none;
    transition: background 0.2s ease;
}

.IpRowComponent_ipItem__oN47v:hover {
    background: rgba(44, 50, 66, 0.95);
    border-color: rgba(92, 184, 92, 0.4);
}

/* Linke Spalte: IP & Hostname */
.IpRowComponent_ipLeft__YKyPZ {
    display: flex;
    flex-direction: column;
    min-width: 160px;
    flex-shrink: 0;
}

.IpRowComponent_ipAddress__L8LkX {
    font-family: 'Roboto Mono', monospace;
    font-weight: 700;
    font-size: 1rem;
    color: greenyellow;
    line-height: 1.2;
}

.IpRowComponent_hostname__XcpUF {
    font-size: 0.75rem;
    color: #a0a8b0;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
}

/* Mittlere Spalte: Geo-Infos & Org */
.IpRowComponent_ipMid__ct8iu {
    flex: 1 1;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    color: #f0f0f0;
    font-size: 0.85rem;
    min-width: 0; /* Ermöglicht Text-Kürzung falls nötig */
}

.IpRowComponent_ipInfoGroup__XbVA2 {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    overflow: hidden;
}

.IpRowComponent_orgText__t5ohX {
    opacity: 0.7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.IpRowComponent_flag__v5SdD {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.IpRowComponent_flag__v5SdD img {
    width: 22px !important;
    height: auto;
    border-radius: 2px;
}

.IpRowComponent_trenner__ACc\\+e {
    color: #5a5f70;
}

/* Rechte Spalte: Status Tags & Action */
.IpRowComponent_ipRight__iQSyw {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex-shrink: 0;
}

.IpRowComponent_statusTag__vp6Cy {
    min-width: 80px; /* Einheitliche Breite für saubere Spalten-Optik */
    height: 26px;
    padding: 0 8px;
    font-size: 0.7rem;
    font-weight: 700;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    white-space: nowrap;
}

/* Status Farben */
.IpRowComponent_abuseDanger__0Ibp5  { background: #d9534f; color: #fff; }   
.IpRowComponent_abuseWarning__gT0Fk { background: #f0ad4e; color: #fff; }     
.IpRowComponent_abuseSuccess__wfM40 { background: #5cb85c; color: #fff; }   
.IpRowComponent_pingSuccess__0eLby  { background: #5cb85c; color: #fff; }
.IpRowComponent_pingDanger__zeHn-   { background: #d9534f; color: #fff; }
.IpRowComponent_blocked__T59vy      { background: #d9534f; color: #fff; }
.IpRowComponent_clean__3FeAZ        { background: #5cb85c; color: #fff; }
.IpRowComponent_noInfo__hmGF4       { background: #5a5f70; color: #f0f0f0; }

.IpRowComponent_addButton__0YGIx {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    cursor: pointer;
    transition: all 0.2s;
}

.IpRowComponent_addButton__0YGIx:hover {
    background: #5cb85c;
    border-color: transparent;
}

.IpRowComponent_addButton__0YGIx svg {
    width: 16px;
    height: 16px;
    stroke: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/components/IpRowComponent.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB,EAAE,8CAA8C;IACtE,qBAAqB;IACrB,aAAa;IACb,mBAAmB,EAAE,wCAAwC;IAC7D,8BAA8B;IAC9B,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY,EAAE,wCAAwC;AAC1D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe,EAAE,kDAAkD;IACnE,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,WAAW,EAAE;AAClD,sCAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".ipItem {\n    background: rgba(32, 38, 50, 0.85); \n    backdrop-filter: blur(8px);\n    border-radius: 8px;\n    padding: 0.6rem 1.2rem; /* Etwas flacher für mehr Informationsdichte */\n    margin-bottom: 0.6rem;\n    display: flex;\n    align-items: center; /* Vertikale Zentrierung aller Spalten */\n    justify-content: space-between;\n    gap: 1.5rem;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    list-style: none;\n    transition: background 0.2s ease;\n}\n\n.ipItem:hover {\n    background: rgba(44, 50, 66, 0.95);\n    border-color: rgba(92, 184, 92, 0.4);\n}\n\n/* Linke Spalte: IP & Hostname */\n.ipLeft {\n    display: flex;\n    flex-direction: column;\n    min-width: 160px;\n    flex-shrink: 0;\n}\n\n.ipAddress {\n    font-family: 'Roboto Mono', monospace;\n    font-weight: 700;\n    font-size: 1rem;\n    color: greenyellow;\n    line-height: 1.2;\n}\n\n.hostname {\n    font-size: 0.75rem;\n    color: #a0a8b0;\n    margin-top: 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 180px;\n}\n\n/* Mittlere Spalte: Geo-Infos & Org */\n.ipMid {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    color: #f0f0f0;\n    font-size: 0.85rem;\n    min-width: 0; /* Ermöglicht Text-Kürzung falls nötig */\n}\n\n.ipInfoGroup {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    overflow: hidden;\n}\n\n.orgText {\n    opacity: 0.7;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.flag {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.flag img {\n    width: 22px !important;\n    height: auto;\n    border-radius: 2px;\n}\n\n.trenner {\n    color: #5a5f70;\n}\n\n/* Rechte Spalte: Status Tags & Action */\n.ipRight {\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    flex-shrink: 0;\n}\n\n.statusTag {\n    min-width: 80px; /* Einheitliche Breite für saubere Spalten-Optik */\n    height: 26px;\n    padding: 0 8px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n/* Status Farben */\n.abuseDanger  { background: #d9534f; color: #fff; }   \n.abuseWarning { background: #f0ad4e; color: #fff; }     \n.abuseSuccess { background: #5cb85c; color: #fff; }   \n.pingSuccess  { background: #5cb85c; color: #fff; }\n.pingDanger   { background: #d9534f; color: #fff; }\n.blocked      { background: #d9534f; color: #fff; }\n.clean        { background: #5cb85c; color: #fff; }\n.noInfo       { background: #5a5f70; color: #f0f0f0; }\n\n.addButton {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.addButton:hover {\n    background: #5cb85c;\n    border-color: transparent;\n}\n\n.addButton svg {\n    width: 16px;\n    height: 16px;\n    stroke: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ipItem": `IpRowComponent_ipItem__oN47v`,
	"ipLeft": `IpRowComponent_ipLeft__YKyPZ`,
	"ipAddress": `IpRowComponent_ipAddress__L8LkX`,
	"hostname": `IpRowComponent_hostname__XcpUF`,
	"ipMid": `IpRowComponent_ipMid__ct8iu`,
	"ipInfoGroup": `IpRowComponent_ipInfoGroup__XbVA2`,
	"orgText": `IpRowComponent_orgText__t5ohX`,
	"flag": `IpRowComponent_flag__v5SdD`,
	"trenner": `IpRowComponent_trenner__ACc+e`,
	"ipRight": `IpRowComponent_ipRight__iQSyw`,
	"statusTag": `IpRowComponent_statusTag__vp6Cy`,
	"abuseDanger": `IpRowComponent_abuseDanger__0Ibp5`,
	"abuseWarning": `IpRowComponent_abuseWarning__gT0Fk`,
	"abuseSuccess": `IpRowComponent_abuseSuccess__wfM40`,
	"pingSuccess": `IpRowComponent_pingSuccess__0eLby`,
	"pingDanger": `IpRowComponent_pingDanger__zeHn-`,
	"blocked": `IpRowComponent_blocked__T59vy`,
	"clean": `IpRowComponent_clean__3FeAZ`,
	"noInfo": `IpRowComponent_noInfo__hmGF4`,
	"addButton": `IpRowComponent_addButton__0YGIx`
};
export default ___CSS_LOADER_EXPORT___;
